import React, { FC } from 'react';

import { UploadItemProps } from './types';

import { FileName, FileProgress } from './styled';

const UploadHeaderContent: FC<
  Pick<UploadItemProps, 'file' | 'listType'> & { onPreview?: () => void }
> = ({ file, listType, onPreview }) => {
  return (
    <>
      {(!file.error || listType !== 'text') && (
        <FileName onClick={onPreview}>{file.name || file.fileName}</FileName>
      )}

      {listType !== 'text' && file.status && file.status !== 'error' && (
        <FileProgress>{file.percent}%</FileProgress>
      )}
    </>
  );
};

export default UploadHeaderContent;
